import React, { useEffect } from 'react'
import PropTypes from 'prop-types'
import { Helmet } from 'react-helmet'
import loadable from '@loadable/component'
import { parse as parseQueryString } from 'query-string'

import CssBaseline from '@material-ui/core/CssBaseline'
import { ThemeProvider } from '@material-ui/core/styles'

import AuthProvider from 'src/providers/AuthProvider'

import theme from 'src/theme'

import localStorageWrapper from 'src/util/localStorageWrapper'
import sessionStorageWrapper from 'src/util/sessionStorageWrapper'

import { StoreProvider, reducer, useStore, actions, initialState } from 'store'
import isBrowser from 'src/util/isBrowser'

// i18n needs to be imported
// eslint-disable-next-line no-unused-vars
import i18n from 'src/i18n'

const Notices = loadable(() => import('src/Notices'))

const getPromoAndReferralcode = (search) => {
  const oneDay = 60 * 60 * 24 * 1000

  const query = parseQueryString(search)

  let referralCode = query.referralCode
  let referralCodeValid = true
  let promoCode = query.promoCode
  if (referralCode) {
  } else {
    referralCode = sessionStorageWrapper.getItem('referralCode')
  }

  // check for old, invalid referralCodes
  if (referralCode) {
    const referralDealVersion = Number(referralCode.split('-')[2])
    if (!referralDealVersion) {
      sessionStorage.removeItem('referralCode')
      referralCodeValid = false
      referralCode = undefined
    }
  }

  if (promoCode) {
    promoCode = promoCode.toUpperCase()
    localStorageWrapper.setItem('promoCode', promoCode)
    localStorageWrapper.setItem('promoCodeSetAt', new Date())
  } else {
    promoCode = localStorageWrapper.getItem('promoCode')
    // default setAt to 0 so if referralCodeSetAt is not set so it times out
    const setAt = new Date(localStorageWrapper.getItem('promoCodeSetAt', 0))

    if (promoCode) {
      promoCode = promoCode.toUpperCase()
    }

    // if older than 1 day, remove
    if (new Date() - setAt > oneDay * 1) {
      localStorageWrapper.removeItem('promoCode')
      localStorageWrapper.removeItem('promoCodeSetAt')
      promoCode = undefined
    }
  }

  if (promoCode && referralCode) {
    // can't have both
    sessionStorageWrapper.removeItem('referralCode')
    referralCode = undefined
  }

  return { referralCode, promoCode, referralCodeValid }
}

const SaveReferralAndPromoCode = () => {
  const [, dispatch] = useStore()
  useEffect(() => {
    if (isBrowser() && __BUILDFOR__ === ' ') {
      const codes = getPromoAndReferralcode(window.location.search)
      dispatch(actions.setPromoCodeAndReferralcode(codes))
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return null
}

const SetStoreFromLocalStorageAndQuery = () => {
  const [, dispatch] = useStore()
  useEffect(() => {
    if (isBrowser()) {
      const { setLoginEmail, token } = parseQueryString(window.location.search)
      const loginEmail =
        setLoginEmail || localStorageWrapper.getItem('loginEmail')

      // always blocking so we force people to give their email preferences
      dispatch(actions.setNoticeBlocking(true))

      const noticeHidden = JSON.parse(
        localStorageWrapper.getItem('noticeHiddenNew', true),
      )

      dispatch(
        actions.setLoginInfo({
          loginEmail,
          loginKey: token,
        }),
      )
      dispatch(
        actions.setAirbnbStrongerTogetherBannerOpen({
          // JSON.parse converts its input to text,
          // so true will get parsed as "true"
          open: JSON.parse(
            localStorageWrapper.getItem(
              'airbnbStrongerTogetherBannerOpen',
              true,
            ),
          ),
        }),
      )

      dispatch(
        actions.setNoticeSettings({
          blocking: true,
          hidden: !!noticeHidden,
        }),
      )
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return null
}

const SaveUTMParams = () => {
  const [, dispatch] = useStore()
  useEffect(() => {
    if (isBrowser()) {
      const { utm_source } = parseQueryString(window.location.search)
      if (utm_source) {
        dispatch(actions.saveSourceFromUtmTags(utm_source))
      }
    }
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  return null
}

export default function TopLayout(props) {
  return (
    <>
      <Helmet>
        <html lang="nl" />
        <meta name="theme-color" content="#fff" />

        <meta property="og:type" content="business.business" />
        <meta property="og:url" content="/" />
      </Helmet>
      <ThemeProvider theme={theme}>
        {/* CssBaseline kickstart an elegant, consistent, and simple baseline to build upon. */}
        <CssBaseline />
        <StoreProvider initialState={initialState} reducer={reducer}>
          <SaveReferralAndPromoCode />
          <SetStoreFromLocalStorageAndQuery />
          <SaveUTMParams />
          <AuthProvider>{props.children}</AuthProvider>
          <Notices />
        </StoreProvider>
      </ThemeProvider>
    </>
  )
}

TopLayout.propTypes = {
  children: PropTypes.node,
}
